export enum ConfigureLineItemTestInputEnum {
  CL_INPUT = 'cl-input',
  QUANTITY_INPUT = 'quantity-input',
}

export enum ConfigureLineItemTestButtonEnum {
  BACK_TO_CATALOG_BTN = 'back-to-catalog-btn',
}
